import { createRootRoute, Outlet } from '@tanstack/react-router'
import { ReactNode } from "react";
import { Box } from "@mui/system";
import Header from "../components/Header";
import '@rainbow-me/rainbowkit/styles.css';
import { http } from "viem"
import {
  getDefaultConfig,
  RainbowKitProvider,
} from '@rainbow-me/rainbowkit';
import { WagmiProvider } from 'wagmi';
import {
  QueryClientProvider,
  QueryClient,
} from "@tanstack/react-query";
import { ManageVaultContextProvider } from '../context/ManageVaultContext';
import { ManageOracleRouterContextProvider } from '../context/ManageOracleRouterContext';
import { SnackbarProvider } from 'notistack';
import { arbitrum, base, mainnet, polygon, sonic, ink, swellchain, bob, unichain, berachain, bsc, avalanche, corn, optimism, gnosis, worldchain, morph } from 'viem/chains';
import { AddressBookContextProvider } from '../context/AddressBookContext';
import AddToAddressBookModal from '../components/AddToAddressBookModal';
import TosModal from '../components/TosModal';
import Footer from '../components/Footer';

const config = getDefaultConfig({
  appName: 'EVK Vault Manager',
  projectId: '9e300f1a1f8184b813acdfc9d337a299',
  chains: [mainnet, base, swellchain, sonic, berachain, bob, avalanche, bsc, unichain, /*arbitrum, polygon, ink, , corn, optimism, gnosis, worldchain, morph*/],
  transports: {
    [mainnet.id]: http('https://white-ancient-sanctuary.quiknode.pro/78449491787fdc3a137ab543e6dfd8d9d10aa6f2'),
    [arbitrum.id]: http('https://white-ancient-sanctuary.arbitrum-mainnet.quiknode.pro/78449491787fdc3a137ab543e6dfd8d9d10aa6f2'),
    [polygon.id]: http('https://white-ancient-sanctuary.matic.quiknode.pro/78449491787fdc3a137ab543e6dfd8d9d10aa6f2'),
    [optimism.id]: http('https://white-ancient-sanctuary.optimism.quiknode.pro/78449491787fdc3a137ab543e6dfd8d9d10aa6f2'),
    [base.id]: http('https://white-ancient-sanctuary.base-mainnet.quiknode.pro/78449491787fdc3a137ab543e6dfd8d9d10aa6f2'),
    [gnosis.id]: http('https://white-ancient-sanctuary.xdai.quiknode.pro/78449491787fdc3a137ab543e6dfd8d9d10aa6f2'),
    [bsc.id]: http('https://white-ancient-sanctuary.bsc.quiknode.pro/78449491787fdc3a137ab543e6dfd8d9d10aa6f2'),
    [avalanche.id]: http('https://white-ancient-sanctuary.avalanche-mainnet.quiknode.pro/78449491787fdc3a137ab543e6dfd8d9d10aa6f2/ext/bc/C/rpc/'),
    [sonic.id]: http('https://rpc.ankr.com/sonic_mainnet/91917bb8e3a5c5f736333312b361027651a18402aeed8685452ac29bde4d6bd4'),
    [swellchain.id]: http('https://swellchain.gateway.tenderly.co/3PnLF1aLdsaAORvjFn8bQv'),
    [ink.id]: http('https://white-ancient-sanctuary.ink-mainnet.quiknode.pro/78449491787fdc3a137ab543e6dfd8d9d10aa6f2'),
    [bob.id]: http('https://bob.gateway.tenderly.co/3lJlyWwFcXguIFSG5WaW69'),
    [unichain.id]: http('https://white-ancient-sanctuary.unichain-mainnet.quiknode.pro/78449491787fdc3a137ab543e6dfd8d9d10aa6f2'),
    [berachain.id]: http('https://white-ancient-sanctuary.bera-mainnet.quiknode.pro/78449491787fdc3a137ab543e6dfd8d9d10aa6f2'),
    [corn.id]: http('https://mainnet.corn-rpc.com'),
    [worldchain.id]: http('https://white-ancient-sanctuary.worldchain-mainnet.quiknode.pro/78449491787fdc3a137ab543e6dfd8d9d10aa6f2'),
    [morph.id]: http('https://white-ancient-sanctuary.morph-mainnet.quiknode.pro/78449491787fdc3a137ab543e6dfd8d9d10aa6f2')
  },
  ssr: true, // If your dApp uses server side rendering (SSR)
});

const queryClient = new QueryClient();

const Providers = (props: { children: ReactNode }) => {
  return (
    <SnackbarProvider>
      <WagmiProvider config={config}>
        <QueryClientProvider client={queryClient}>
          <RainbowKitProvider>
            <AddressBookContextProvider>
              <ManageVaultContextProvider>
                <ManageOracleRouterContextProvider>
                  {props.children}
                </ManageOracleRouterContextProvider>
              </ManageVaultContextProvider>
            </AddressBookContextProvider>
          </RainbowKitProvider>
        </QueryClientProvider>
      </WagmiProvider>
    </SnackbarProvider>
  );
};

export const Route = createRootRoute({
  component: () => (
    <Providers>
      {/* <Header /> */}
      {/* <Box> */}
      <Box className="contentAndFooterContainer" display={"flex"} flexDirection={"column"} flexGrow={1} minHeight={"100%"}>
        <Header />
        <Box flexGrow={1}>
          <Outlet />
        </Box>
        <Footer />
      </Box>
      {/* </Box> */}

      
      {/* <TanStackRouterDevtools /> */}
      <AddToAddressBookModal />
      <TosModal />
    </Providers>
  ),
})
